import React from 'react';
import { BarChart2, Hash, TrendingUp } from 'lucide-react';
import { formatAmount } from '../../../utils/format/number';

interface TransactionDistributionProps {
  totalVolume: number;
  userTxCount: number;
  avgAmount: number;
}

export default function TransactionDistribution({ totalVolume, userTxCount, avgAmount }: TransactionDistributionProps) {
  const items = [
    { label: 'Total Volume', value: formatAmount(totalVolume) + ' TWINS', icon: TrendingUp },
    { label: 'Transactions', value: userTxCount.toString(), icon: Hash },
    { label: 'Average', value: formatAmount(avgAmount) + ' TWINS', icon: BarChart2 },
  ];

  return (
    <div className="space-y-3">
      {items.map(({ label, value, icon: Icon }) => (
        <div key={label} className="p-3 md:p-4 bg-slate-900/50 rounded-lg flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon className="h-4 w-4 text-green-500" />
            <span className="text-sm text-gray-400">{label}</span>
          </div>
          <span className="font-mono text-sm text-green-400">{value}</span>
        </div>
      ))}
    </div>
  );
}
